export default "__VITE_ASSET__b5a1bb1a__"